import Head from 'next/head'
import { type ReactElement } from 'react'
import { determineBrowserTabName } from '../../../shared/themes/logoFunctions'
import { RequestMerchantsForm } from './RequestMerchantsForm'

export function Container (): ReactElement {
  return (
    <>
      <Head>
        <title>Request Merchant - {determineBrowserTabName()}</title>
      </Head>

      <div className="flex justify-center items-center h-screen">
        <RequestMerchantsForm />
      </div>
    </>
  )
}
